/**
 * Lightweight cookie/consent preference store.
 *
 * Consent is kept in localStorage so it survives across sessions. Only
 * "necessary" cookies are used until the visitor makes a choice.
 */
export const CONSENT_STORAGE_KEY = "zu-cookie-consent-v1";
export const CONSENT_EVENT = "zu:cookie-consent";

export const DEFAULT_CONSENT = {
  necessary: true,
  analytics: false,
  marketing: false,
};

export function getConsent() {
  if (typeof window === "undefined") return null;
  try {
    const raw = window.localStorage.getItem(CONSENT_STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== "object") return null;
    return {
      ...DEFAULT_CONSENT,
      analytics: Boolean(parsed.analytics),
      marketing: Boolean(parsed.marketing),
      updatedAt: parsed.updatedAt || null,
    };
  } catch (err) {
    return null;
  }
}

export function hasChosen() {
  return getConsent() !== null;
}

export function saveConsent(prefs) {
  if (typeof window === "undefined") return DEFAULT_CONSENT;
  const value = {
    ...DEFAULT_CONSENT,
    analytics: Boolean(prefs && prefs.analytics),
    marketing: Boolean(prefs && prefs.marketing),
    updatedAt: new Date().toISOString(),
  };
  try {
    window.localStorage.setItem(CONSENT_STORAGE_KEY, JSON.stringify(value));
  } catch (err) {
    /* storage blocked - consent stays session-only */
  }
  window.dispatchEvent(new CustomEvent(CONSENT_EVENT, { detail: value }));
  return value;
}

export function clearConsent() {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.removeItem(CONSENT_STORAGE_KEY);
  } catch (err) {
    /* ignore */
  }
  window.dispatchEvent(new CustomEvent(CONSENT_EVENT, { detail: null }));
}

/** Open the preferences panel from anywhere (e.g. a footer link). */
export function openCookieSettings() {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new CustomEvent("zu:open-cookie-settings"));
}
